import React, { useState, useEffect } from 'react';

import { useAuthenticator } from "@aws-amplify/ui-react";

import "./LandingPage.css";

export const LandingPage = () => {
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);

    useEffect(() => {
        if (authStatus === "authenticated") {
            window.location.href = "/home";
        }
    }, [authStatus]);

    return (
        <div className='page-content'>
            <h1>Understand your sales workflows!</h1>
            <div className="fp-content columns-3">
                <div>Do you know what your sales look like?</div>
                <div className="centered">
                    <i className="fa-solid fa-arrow-right fa-xl"></i>
                </div>
                <div>
                    <p>PurpleGrove can help you to answer all of these questions and more!</p>
                </div>
            </div>
            <div className="fp-content centered">
                <div>
                    <button className="get-started-button">Get Started</button>
                </div>
                <div>
                    Get started on the free tier, no credit card required.
                </div>
            </div>
            <div className="fp-content columns-2">
                <div>Sleep peacefully</div>
                <div>Screenshot goes here</div>
            </div>
        </div>
    );
};